<template>
  <SplashScreenComponent v-if="showSplash" @remove-splash="onSplashRemoved" />
  <router-view v-else />
</template>

<script>
import SplashScreenComponent from "./components/splashScreen.vue";

export default {
  components: {
    SplashScreenComponent,
  },
  data() {
    return {
      showSplash: true,
    };
  },
  created() {
    this.getLang();
  },

  methods: {
    getLang() {
      if (localStorage.getItem("lang")) {
        this.$i18n.locale = localStorage.getItem("lang");
      } else {
        this.$i18n.locale = "ar";
        localStorage.setItem("lang", this.$i18n.locale);
      }
    },
    onSplashRemoved() {
      this.showSplash = false;
    },
  },
};
</script>
<style lang="scss">
.v-btn {
  letter-spacing: 0 !important;
}
:root {
  --font: "somer";
}
@font-face {
  font-family: "somer";
  src: local("somer"),
    url(./assets/fonts/TTF/Standard/SomarSans-Regular.ttf) format("truetype");
}

* {
  font-family: "somer";
}

::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #313942;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e85827;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #e85827;
}
.slider {
  display: block;
  /* other styles */
}

/* For mobile screens */
@media only screen and (max-width: 767px) {
  ::-webkit-scrollbar {
    width: 0px;
    display: none;
  }
}
</style>
